import { CompaniesStateType } from './companies.reducer';

export const getDetail = (state: CompaniesStateType) => state.details;

export const hasData = ({ details }: CompaniesStateType) =>
  details.completedStandards.length > 0 ||
  details.requests.in.length > 0 ||
  details.requests.out.length > 0;
